import { Box, Container, Typography, useTheme } from '@mui/material';
import { SectionTitleFontSize } from '../HomeView';

/**
 * This section displays an example of our certificate that we award to students
 */
const CertificationSection = () => {
  const theme = useTheme();
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="md" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h4"
          fontWeight="bold"
          gutterBottom
          fontSize={SectionTitleFontSize}
        >
          Certification & Compliance
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Every learner receives an official certificate upon completion of each
          course.
        </Typography>
        <img
          src="/s3g-certificate-example.png"
          style={{
            marginTop: '3em',
            borderColor: theme.palette.text.primary,
            borderWidth: '1px',
            borderStyle: theme.palette.mode == 'light' ? 'solid' : 'none',
            maxWidth: '100%',
            maxHeight: '400px',
            height: 'auto',
          }}
        />
      </Container>
    </Box>
  );
};

export default CertificationSection;
